// removed by extract-text-webpack-plugin
module.exports = {"title":"UploadDialog__title___1ccSw","completeIcon":"UploadDialog__completeIcon___7e2i7","body":"UploadDialog__body___26tBH","circle":"UploadDialog__circle___37fgH","doneIcon":"UploadDialog__doneIcon___3Eloy","percentText":"UploadDialog__percentText___2Bmwk","completeLabel":"UploadDialog__completeLabel___OLKLn","progressBar":"UploadDialog__progressBar___2luTH"};


//////////////////
// WEBPACK FOOTER
// ./src/submission/components/UploadDialog.css
// module id = 770
// module chunks = 0